import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Product } from 'package-types/devices/socketEvents';

@Component({
  selector: 'app-simple-product',
  templateUrl: './simple-product.component.html',
  styleUrls: ['./simple-product.component.scss'],
  standalone: false,
})
export class SimpleProductComponent implements OnInit {
  i18n = inject(TranslateService);

  @Input('product') product: Product;
  @Input('image') image: string;

  @Output() select: EventEmitter<any> = new EventEmitter();

  ngOnInit() {}

  emitSelect() {
    this.select.emit(this.product);
  }
}
